import type { hearts } from "@app/rules";
import { useT } from "../i18n/context";
import type { PassChoice } from "./passChoice";
import { Key, Sheet } from "./Sheet";

/** Hearts, before a hand: three cards to a neighbour, named in words and not only by an arrow. */
export function PassSheet({
  view,
  names,
  choice,
  dense = false,
}: {
  view: hearts.HeartsView;
  names: (string | null)[];
  choice: PassChoice;
  dense?: boolean;
}) {
  const { t } = useT();
  const { direction, to } = view.pass;
  if (direction === "hold") return null;
  const count = choice.selected.size;
  const name = to === null ? "?" : (names[to] ?? "?");
  return (
    <Sheet
      title={t("hearts.pass.title")}
      aside={t(`hearts.pass.${direction}`, { name })}
      labelId="pass-title"
      dense={dense}
    >
      <div className="flex items-center justify-between gap-3">
        <span aria-live="polite" className="text-[13px] text-ink/75">
          {choice.ready ? t("hearts.pass.count", { count }) : t("hearts.pass.need", { count })}
        </span>
        <Key
          label={t("hearts.pass.send")}
          tone="gold"
          dense
          disabled={!choice.ready}
          className="flex-none rounded-pill px-9 text-[15px]"
          onClick={choice.submit}
        />
      </div>
    </Sheet>
  );
}
